const ubiHtmlViewer = null;

export function CallReport(jrffile, arg, ubiEvents, target, serviceapiurl, password, reporttitle) {
  const rptType = /.jef/;
  let scale = 200;
  if (rptType.test(jrffile)) {
    scale = 180;
    ubiEvents = { "eformevent.saveend": ubiEformSaveEnd };
  }

  const REPORT_URL = process.env.NODE_ENV === "production"
    ? "https://kocpinthklwap03.azurewebsites.net"
    : "https://taxtron-report.azurewebsites.net";
  const ubiParams = {
    appurl: REPORT_URL, //오류가 발생한다면 "appurl":appUrl 로 호출 // process.env.NEXT_PUBLIC_RPT_URL 해당값 안넘어옴
    key: getRandomKey(),
    jrffile,
    arg,
    resid: "UBIHTML",
    resource: "/ubi4/js",
    divid: target,
    serviceapiurl,
    servicedatanodename: "payload",
    password,
    reporttitle,
    isPdfOutline: "true",
    scale
  };
  ubiStart(ubiHtmlViewer, ubiParams, ubiEvents);
}

export function ubiStart(ubiHtmlViewer, ubiParams, ubiEvents) {
  // eslint-disable-next-line no-undef
  ubiHtmlViewer = UbiLoad(ubiParams, ubiEvents);
  console.log("UBI : ", ubiHtmlViewer);
}

export function getRandomKey() {
  let key = "";
  const nowdate = new Date();
  const year = nowdate.getFullYear();
  let month = nowdate.getMonth() + 1;
  let day = nowdate.getDate();
  let hour = nowdate.getHours();
  let min = nowdate.getMinutes();
  let sec = nowdate.getSeconds();
  const milsec = nowdate.getMilliseconds();

  if ((`${month}`).length === 1) { month = `0${month}`; }
  if ((`${day}`).length === 1) { day = `0${day}`; }
  if ((`${hour}`).length === 1) { hour = `0${hour}`; }
  if ((`${min}`).length === 1) { min = `0${min}`; }
  if ((`${sec}`).length === 1) { sec = `0${sec}`; }

  // eslint-disable-next-line no-bitwise
  key = `${year}${month}${day}${hour}${min}${sec}${milsec}_${(Math.random() * (1 << 30)).toString(16).replace(".", "")}`;

  return key;
}

function ubiEformSaveEnd(file) {
  const iframe = document.createElement("iframe");
  iframe.setAttribute("id", "ubidown_frame");
  iframe.setAttribute("name", "ubidown_frame");
  iframe.setAttribute("height", "0");
  iframe.setAttribute("width", "0");
  document.getElementsByTagName("body")[0].appendChild(iframe);

  const form = document.createElement("form");
  form.setAttribute("method", "post");
  form.setAttribute("action", `${process.env.PUBLIC_RPT_URL}/ubi4/ubidownload.jsp`);
  form.setAttribute("target", "ubidown_frame");
  // Create an input element for Full Name
  const FN = document.createElement("input");
  FN.setAttribute("type", "hidden");
  FN.setAttribute("name", "saveFileName");
  FN.setAttribute("value", file);
  form.appendChild(FN);
  document.getElementsByTagName("body")[0].appendChild(form);
  form.submit();
}
